import { render, staticRenderFns } from "./AgeCalculator.vue?vue&type=template&id=3dc11f66&scoped=true"
import script from "./AgeCalculator.vue?vue&type=script&lang=js"
export * from "./AgeCalculator.vue?vue&type=script&lang=js"
import style0 from "./AgeCalculator.vue?vue&type=style&index=0&id=3dc11f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc11f66",
  null
  
)

export default component.exports